import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Modal, { Prompt, ModalFooter } from '@ingka/modal'
import Button from '@ingka/button'
import usePrevious from 'hooks/usePrevious'
import { TRACK_LOCATION_DESIGN_SUMMARY } from 'models/tracking/constants'

interface SaveTrackingInfo {
    SavedFrom: string
}
interface DesignSummarySavePopupProps {
    onSave: (trackingInfo?: SaveTrackingInfo) => void
    closeModal: () => void
    isVisible: boolean
    ikeaNav: boolean
    openDesignLab: () => void
    isSaving: boolean
}

const DesignSummarySavePopup = ({
    onSave,
    closeModal,
    isVisible,
    ikeaNav,
    openDesignLab,
    isSaving,
}: DesignSummarySavePopupProps) => {
    const { t } = useTranslation()
    const history = useHistory()
    const prevIsSaving = usePrevious(isSaving)

    const goBack = () => {
        if (ikeaNav) {
            openDesignLab()
        } else {
            history.push(`/dashboard`)
        }
        closeModal()
    }
    useEffect(() => {
        let goBackDelay: ReturnType<typeof setTimeout>
        if (prevIsSaving && !isSaving) {
            goBackDelay = setTimeout(goBack, 1000)
        }
        return () => {
            clearTimeout(goBackDelay)
        }
    }, [prevIsSaving, isSaving, ikeaNav])
    const onSaveAndExit = () => {
        const trackingInfo = {
            SavedFrom: TRACK_LOCATION_DESIGN_SUMMARY,
        }
        onSave(trackingInfo)
    }

    return (
        <Modal visible={isVisible} handleCloseBtn={closeModal} escapable={false}>
            <Prompt
                title={t('designSummaryExit.save design before you leave')}
                footer={
                    <ModalFooter compact>
                        <Button
                            data-autofocus
                            text={t('designSummaryExit.save & exit')}
                            type="primary"
                            onClick={onSaveAndExit}
                        />
                        <Button
                            text={t('designSummaryExit.dont save it')}
                            type="secondary"
                            onClick={() => {
                                closeModal()
                                goBack()
                            }}
                        />
                    </ModalFooter>
                }
            >
                <p>{t('designSummaryExit.saving allows you')}</p>
            </Prompt>
        </Modal>
    )
}

export default DesignSummarySavePopup
